module.exports = __webpack_public_path__ + "static/img/web-logo.4674e8f3.png";